<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";

  export let saveFn: Function = null;
  export let nextFn: Function;
  export let disabled: boolean = false;
  export let backState: string = "";

  const { trackClick } = EventTracking;

  const clickHandler = (fn: Function, target_type: string) => {
    trackClick(target_type);
    fn();
  };

</script>

<div data-grid-area="footer">
  <div class={backState ? "fizz-space-between" : "fizz-flex-row fizz-justify-end"}>
    {#if backState}
      <UIRouterLink
        stateName={backState}
        params={window["stateService"].params}
        classes="fizz-button"
        onClickCB={() => trackClick("onboarding_back_button")}
      >
        Back
      </UIRouterLink>
    {/if}

    <div class="fizz-flex-row">
      {#if saveFn}
        <button
          class="fizz-button-text"
          data-testid="save-and-finish-later-button"
          on:click|preventDefault={() =>
            clickHandler(saveFn, "onboarding_save_and_finish_later_button")}
          {disabled}
        >
          Save and finish later
        </button>
      {/if}
      <button
        class="fizz-button-secondary"
        data-testid="next-button"
        on:click|preventDefault={() => clickHandler(nextFn, "onboarding_next_button")}
        {disabled}
      >
        Next
      </button>
    </div>
  </div>
</div>
